import { Icon, Label, Link, TableColumnConfig, Text, Tooltip } from '@gravity-ui/uikit';
import { VideoInfo } from '../../../types/video/VideoInfo';
import { PLAYER_URL } from '../../../api/constants/URLs';
import { formatDateTime } from '../../../libs/formaters/formatDateTime';
import { VideoStatusLabel } from '../components/VideoStatusLabel';
import { ActionButton } from '../components/ActionButton';
import { MoreActions } from '../components/MoreActions';
import { Dispatch } from 'react';
import { AvailableDialogs } from '../constants/availableDialogs';
import { ProfilesRecord } from '../../Page/types/ProfilesRecord';
import { STAT_URL } from '../constants/STAT_URL';
import { ChartAreaStacked } from '@gravity-ui/icons';
import { SimpleTextTooltip } from '../../ui/SimpleTextPopover/SimpleTextTooltip';
import { videoListT } from '../../../i18n';

/** Ширина кнопочных колонок в мобайле (px) */
const MOBILE_ACTION_COLUMN_WIDTH = 30;

export const getTableColumns = (
    profiles: ProfilesRecord,
    setVideoInfo: Dispatch<VideoInfo>,
    setCurrentOpenedDialog: Dispatch<AvailableDialogs>,
    isMobile?: boolean,
): TableColumnConfig<VideoInfo>[] => {
    // В мобилках — без ширины (займёт оставшееся место при fixed layout)
    const nameColumnWidth = isMobile ? undefined : '60%';
    // В мобилках кнопочные колонки получают явную px-ширину для table-layout: fixed
    const actionColumnWidth = isMobile ? MOBILE_ACTION_COLUMN_WIDTH : undefined;

    return [
        {
            id: 'name',
            name: videoListT('columnFile'),
            width: nameColumnWidth,
            template: (v: VideoInfo) => (
                <Link
                    target="_blank"
                    href={`${PLAYER_URL}/${v.video_id}.html?autoplay=1&mute=1&preload=1`}
                >
                    <SimpleTextTooltip content={v.title}>
                        <Text ellipsis>{v.title}</Text>
                    </SimpleTextTooltip>
                </Link>
            ),
        },
        {
            id: 'date',
            name: videoListT('columnDate'),
            template: (v: VideoInfo) => {
                const dateTime = formatDateTime(v.created_at);
                return (
                    <SimpleTextTooltip content={dateTime.full}>
                        <Text>{dateTime.short}</Text>
                    </SimpleTextTooltip>
                );
            },
        },
        {
            id: 'profile',
            name: videoListT('columnProfile'),
            template: (v: VideoInfo) => (
                <SimpleTextTooltip content={profiles[v.profile]?.description || ''}>
                    <Label>
                        <Text
                            style={{
                                width: 100,
                                display: 'block',
                            }}
                            ellipsis
                        >
                            {profiles[v.profile]?.description}
                        </Text>
                    </Label>
                </SimpleTextTooltip>
            ),
        },
        {
            id: 'status',
            name: videoListT('columnStatus'),
            align: 'center',
            width: actionColumnWidth,
            template: (v: VideoInfo) => <VideoStatusLabel status={v.status} isMobile={isMobile} />,
        },
        {
            id: 'clipboard_btn',
            name: '',
            align: isMobile ? 'center' : undefined,
            width: actionColumnWidth,
            template: (v: VideoInfo) => (
                <ActionButton
                    action="share"
                    onClick={() => {
                        setVideoInfo(v);
                        setCurrentOpenedDialog(AvailableDialogs.SHARE);
                    }}
                />
            ),
        },
        {
            id: 'stat',
            name: '',
            template: (v: VideoInfo) => (
                <Link href={`${STAT_URL}?videoContentId=video/${v.video_id}`} target="_blank">
                    <Tooltip content={videoListT('statistics')}>
                        <div style={{ height: '20px', padding: '3px' }}>
                            <Icon data={ChartAreaStacked} size={14} />
                        </div>
                    </Tooltip>
                </Link>
            ),
        },
        {
            id: 'actions_btn',
            name: '',
            align: isMobile ? 'center' : undefined,
            width: actionColumnWidth,
            template: (v: VideoInfo) => (
                <MoreActions
                    videoInfo={v}
                    setVideoInfo={setVideoInfo}
                    setCurrentOpenedDialog={setCurrentOpenedDialog}
                    isMobile={isMobile}
                />
            ),
        },
    ];
};
